<!-- eslint-disable -->
<template>
  <v-app id="inspire">
      <v-app-bar
          app
          clipped-right
          color="primary"
          dark
      >
        <v-app-bar-nav-icon @click.stop="toggleDrawer"></v-app-bar-nav-icon>
        <v-toolbar-title>Система лицензирования Carbis</v-toolbar-title>
        <v-spacer></v-spacer>
        <!--        <v-btn color="green" @click.stop="drawerRight = !drawerRight">-->
        <!--          <v-icon>mdi-account</v-icon>-->
        <!--        </v-btn>-->
        <div>
          <span v-html="$store.getters.user.fullName"
                class="profile-edit"
                @click="userEditDialog = true"
          ></span>
          <span v-if="$vuetify.breakpoint.smAndUp">
            <span> | </span>
            <span v-html="$store.getters.user.dealerName"></span>
            <span> | </span>
            <span v-html="$store.getters.user.roleName"></span>
          </span>
        </div>
        <v-progress-linear
            absolute
            bottom
            color="primary darken-3"
        />
      </v-app-bar>

      <v-navigation-drawer
          v-model="drawer"
          app
          :width="290"
      >
        <v-list>
          <v-list-item two-line>
            <router-link to="/">
              <img src="../assets/carbis.png" alt="Логотип ГК Карбис">
            </router-link>
          </v-list-item>



          <template v-for="action in $store.getters.sidebarActions">
              <v-list-group :value="false" :prepend-icon="action.icon" v-if="!!action.subActions" :key="action.text" no-action color="primary darken-1">
                <template v-slot:activator>
                  <v-list-item-title>
                    {{action.text}}
                  </v-list-item-title>
                </template>

                <v-list-item v-for="sub in action.subActions" :key="sub.text" class="pl-10" link :to="sub.link" exact color="primary darken-1" style="min-height: 40px; height: 40px;" justify="center">
                  <v-list-item-icon style="align-self: center; margin-right: 20px;">
                    <v-icon>
                      {{ sub.icon }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    {{ sub.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list-group>

              <v-list-item v-else :key="action.text+'else'" link :to="action.link" exact color="primary darken-1">
                <v-list-item-icon>
                  <v-icon>{{ action.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ action.text }}
                </v-list-item-title>
              </v-list-item>
          </template>

          <v-list-item
              link
              to="/help/"
              color="primary darken-1"
          >
            <v-list-item-action>
              <v-icon>mdi-help-box-multiple</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Помощь
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
              link
              @click="logout"
              color="primary darken-1"
          >
            <v-list-item-action>
              <v-icon>mdi-export</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Выход
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-main>
        <v-breadcrumbs :items="$store.getters.crumbs || []">
        </v-breadcrumbs>

        <keep-alive  :exclude="excludeComponents">
          <router-view v-if="hasAccess" />
          <v-container v-else fluid class="pt-0">
            <v-card min-width="100%">
              <v-card-text>У вас нет доступа к этой странице</v-card-text>
            </v-card>
          </v-container>
        </keep-alive>

        <v-snackbar
            v-model="$store.getters.snackbar.show"
            :top="!$store.getters.snackbar.large"
            :centered="$store.getters.snackbar.large"
            :vertical="$store.getters.snackbar.large"
            :class="{ 'snackbar-large': $store.getters.snackbar.large }"
            :color="$store.getters.snackbar.color"
            :timeout="$store.getters.snackbar.timeout"
        >
          {{ $store.getters.snackbar.text }}

          <template v-slot:action="{ attrs }">
            <v-btn
                dark
                text
                v-bind="attrs"
                @click="$store.commit('hideSnackbar')"
            >
              {{ $store.getters.snackbar.closeText }}
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="serverBinDialog" max-width="620" persistent scrollable>
          <v-card>
            <v-card-title class="headline">Важная информация</v-card-title>
            <v-card-text class="text-body-2 pt-2">
              <p>
                Во всех модулях разработки «Карбис» есть файл <b>server.bin</b>, отвечающий
                за связь с системой лицензирования. Этот файл всегда находится рядом
                с exe-файлом программы.
              </p>
              <p>
                Для корректной работы системы лицензирования до сентября 2026 необходимо
                заменить его, подложив новый актуальный файл —
                <a href="https://lic.carbis.ru/downloads/server_bin"
                   @click.prevent="downloadServerBin">ссылка на скачивание</a>.
              </p>
              <p>
                Размер правильного файла <b>server.bin</b> — 72 байта.
              </p>
              <p class="mb-0">
                Альтернативный вариант — обновить ПО на последнюю версию, т.к. все актуальные
                дистрибутивы уже содержат новый (правильный) файл.
              </p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="px-6 py-3">
              <v-spacer></v-spacer>
              <v-checkbox
                  v-model="serverBinDontShow"
                  label="Больше не показывать"
                  hide-details
                  dense
                  class="mt-0 pt-0 mr-4 flex-grow-0"
              ></v-checkbox>
              <v-btn color="primary darken-1" text @click="closeServerBinNotice">Закрыть</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="userEditDialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Изменение данных профиля</span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-form>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field label="Фамилия Имя (Отчество)"
                                  v-model="$store.getters.user.fullName"
                                  hide-details
                                  disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="Email"
                                  v-model="$store.getters.user.email"
                                  hide-details
                                  disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field label="Дилер"
                                  v-model="$store.getters.user.dealerName"
                                  hide-details
                                  disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="Роль"
                                  v-model="$store.getters.user.roleName"
                                  hide-details
                                  disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field label="Телефон"
                                  v-model="userEdit.phone"
                                  hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="Пароль"
                                  v-model="userEdit.password"
                                  hide-details
                    >
                      <template v-slot:append>
                        <v-btn text x-small
                               @click="userEdit.password = generatePassword()"
                        >
                          Случайный
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-switch class="mt-0"
                              v-model="userEdit.receiveEmails"
                              label="Получать рассылку"
                              hint="Предупреждение (за 10 дней) об окончании лицензии на почту"
                              persistent-hint
                    >
                    </v-switch>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1"
                     text
                     @click="updateSelf"
              >Сохранить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-main>

      <!--      <v-navigation-drawer-->
      <!--          v-model="drawerRight"-->
      <!--          app-->
      <!--          right-->
      <!--          clipped-->
      <!--          disable-resize-watcher-->
      <!--          temporary-->
      <!--          width="250px"-->
      <!--      >-->
      <!--        <v-list-item>-->
      <!--          <v-list-item-action>-->
      <!--            <v-icon>mdi-account</v-icon>-->
      <!--          </v-list-item-action>-->

      <!--          <v-list-item-content>-->
      <!--            <v-list-item-title>{{ $store.getters.fullname }}</v-list-item-title>-->
      <!--          </v-list-item-content>-->
      <!--        </v-list-item>-->

      <!--        <div class="ma-2">-->
      <!--          <v-btn depressed large block color="success" @click="logout">LOGOUT</v-btn>-->
      <!--        </div>-->
      <!--      </v-navigation-drawer>-->

      <v-footer
          app
          color="green"
          class="white--text"
      >
        <span><a href="https://carbis.ru/">Carbis.ru</a> &copy; 2018-{{ new Date().getFullYear() }}</span>
      </v-footer>
  </v-app>
</template>

<script>
import API from "@/axios/api";
import { getCookie, setCookie } from "@/utils/cookies";

const SERVER_BIN_NOTICE_COOKIE = 'carbis_notice_server_bin';

export default {
  data: () => ({
    userEdit: {
      password: '',
      phone: '',
      receiveEmails: false,
    },
    userEditDialog: false,
    serverBinDialog: false,
    serverBinDontShow: false,
    drawer: null,
    drawerRight: false,
    excludeComponents: [
      'UserEdit',
      'ModuleEdit',
      'LicenseEdit',
      'DealerCreate',
      'MasterCreate',
      'MasterOrder',
      'ModuleCreate',
      'ObjectCreate',
      'UserCreate',
      'OurLegalEntityCreate',
      'OurLegalEntityEdit',
    ],

    notEmptyRule: v => !!v || 'Поле не может быть пустым',
  }),
  computed: {
    hasAccess() {
      return this.$store.getters.hasAccess
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.$store.getters.sidebarActions.forEach(action => {
          if (action.subActions && action.subActions.map(subAction => subAction.link).includes(this.$route.fullPath))
            this.$store.commit('expandAction', action);
        })
        this.$store.commit('setAccessAvailability', true)
      }
    },
    '$store.getters.user'() {
      this.userEdit.phone = this.$store.getters.user.phone;
      this.userEdit.receiveEmails = this.$store.getters.user.receiveEmails;
    },
  },
  methods: {
    generatePassword() {
      return Array(10)
          .fill('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$')
          .map(x => x[Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1) * x.length)])
          .join('');
    },
    logout() {
      this.$store.dispatch('logout')
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
      localStorage.setItem('drawerOpen', this.drawer);
    },
    closeServerBinNotice() {
      if (this.serverBinDontShow) {
        setCookie(SERVER_BIN_NOTICE_COOKIE, '1');
      }
      this.serverBinDialog = false;
    },
    downloadServerBin() {
      fetch('/downloads/server_bin')
          .then((response) => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.blob();
          })
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'server.bin';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('showSnackbar', {
              color: 'error',
              text: 'Не удалось скачать файл',
            });
          });
    },
    updateSelf() {
      API.post(`users/${this.$store.getters.user.id}/self`, this.userEdit)
          .then((response) => {
            console.log(response.data);
            this.$store.commit('showSnackbar', {
              color: 'success',
              text: 'Информация обновлена',
            })
            if (this.userEdit.password) {
              this.logout();
            } else {
              this.userEditDialog = false;
              this.userEdit.password = '';
              this.$store.dispatch('getUser');
              this.$store.dispatch('updateUsers');
            }
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('showSnackbar', {
              color: 'error',
              text: 'Информация не обновлена',
            })
          });
    },
  },
  created() { 
    const savedDrawer = localStorage.getItem('drawerOpen');
    if (savedDrawer !== null && !this.$vuetify.breakpoint.mobile) {
      this.drawer = savedDrawer === 'true';
    }

    if (this.$store.getters.serverBinNoticePending) {
      this.$store.commit('setServerBinNoticePending', false);
      if (!getCookie(SERVER_BIN_NOTICE_COOKIE)) {
        this.serverBinDialog = true;
      }
    }

    this.$store.dispatch('getDrawer').then(() => {
      this.$store.getters.sidebarActions.forEach(action => {
        if (action.subActions && action.subActions.map(subAction => subAction.link).includes(this.$route.fullPath))
          this.$store.commit('expandAction', action);
      });
      this.userEdit.phone = this.$store.getters.user.phone;
      this.userEdit.receiveEmails = this.$store.getters.user.receiveEmails;
    });
  },
}
</script>

<style scoped>
footer a {
  color: white !important;
  text-decoration: none;
}

.profile-edit {
  cursor: pointer;
  background-color: #429145;
  padding: .2rem .4rem;
  border-radius: 5px;
  white-space: nowrap;
}

.snackbar-large ::v-deep .v-snack__wrapper {
  max-width: 640px;
  padding: 12px;
}

.snackbar-large ::v-deep .v-snack__content {
  font-size: 1.25rem;
  line-height: 1.6;
}

.snackbar-large ::v-deep .v-snack__btn {
  font-size: 1.1rem;
}
</style>
